





































import Vue from 'vue'
import Component from "vue-class-component";
import { Prop, Ref } from 'vue-property-decorator';
import {Action} from "vuex-class";
import { getErrorMessage } from '@/utils/notify-helper';

@Component
export default class registrationCodeForm extends Vue {
  @Ref('validator') validator:any;
  @Prop() email!: string;

  @Action("regCodeCheck") actionRequest: any;

  private form = {
    confirmation_code: '',
  }

  async submit() {
    this.$emit('errorMessage', undefined)
    if (!await this.validator.validate()) {
      return
    }
    this.$emit('isProgress', true)
    try {
      const resp = await this.actionRequest({...this.form, email: this.email});
      this.$emit('form', 'registrationForm')
    } catch (e) {
      // const errorMessage = getErrorMessage(e)
      this.$emit('errorMessage', this.$t('errors.incorrect_confirm_code'))
    } finally {
      this.$emit('isProgress', false)
    }
  }

}
